import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartnerWorkspacePage from "@/pages/partner/PartnerWorkspacePage";
export const Route = createFileRoute("/partner/performance")({
  head: () =>
    pageHead(
      "Partner Performance",
      "Your authorized Partner company workspace.",
      "/partner/performance",
      true,
    ),
  component: () => <PartnerWorkspacePage section="performance" />,
});
